import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";
// Get All Bills
export function getAllBills(token, query) {
  const qs = buildQuery(query);
  return axios.get(`${baseUrl}/getallBills${qs}`, {
    headers: {
      authorization: token,
    },
  });
}
// Update a Bill
export function updateBill(id, data, token) {
  return axios.patch(`${baseUrl}/updateBill/${id}`, data, {
    headers: {
      authorization: token,
    },
  });
}

// Add a New Bill
export function createBill(data, token) {
  return axios.post(`${baseUrl}/insertnewBill`, data, {
    headers: {
      authorization: token,
    },
  });
}
// Get a List of Bills with Query Parameters
export function getBillById(token, id) {
  return axios.get(`${baseUrl}/getBillbyID/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

// Delete a Bill
export function deleteBillById(id, token) {
  return axios.delete(`${baseUrl}/deleteBillById/${id}`, {
    headers: {
      Authorization: token,
    },
  });
}

export function ApproveMatchedQuantities(token,data) {
  return axios.post(`${baseUrl}/approveMatchedQuantities`, data, {
    headers: {
      authorization: token,
    },
  });
}
